import React from "react";
import { Col, Card } from "react-bootstrap";
import { getAsset } from "../../../helpers/helper";
import { images } from "../../../constants";

const CandidateCard = ({ candidate, onView }) => {
  return (
    <Col
      xs={12}
      sm={6}
      md={4}
      lg={4}
      xl={3}
      className="px-2 pb-2 mt-2 d-flex"
      key={candidate?._id}
    >
      <Card className="border candidate-card-p p-3 w-100">
        <div className="py-1 d-flex flex-column align-items-center h-100">
          <div className="candidateImg">
            <img
              src={
                candidate?.image && candidate.image[0] && candidate.image[0] !== ""
                  ? getAsset(candidate.image[0])
                  : images.noprofile
              }
              alt="candidate"
              className="candidateImage"
              crossOrigin={
                candidate?.image && candidate.image[0] && candidate.image[0] !== ""
                  ? "anonymous"
                  : undefined
              }
              loading="lazy"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = images.noprofile;
              }}
            />
          </div>

          <h6 className="candidateName mb-0 text-center">{candidate?.name}</h6>

          <p className="candidateOccupation mb-0 font_13 text-center">
            {candidate?.designation}
          </p>

          <div className="d-flex justify-content-around w-100 mt-auto">
            <button
              className="connect-btn mt-2 w-50"
              onClick={() => onView && onView(candidate)}
            >
              View
            </button>
          </div>
        </div>
      </Card>
    </Col>
  );
};

export default CandidateCard;
